import { render } from "./ElectionOfficersReport.vue?vue&type=template&id=60fee8a5&scoped=true"
import script from "./ElectionOfficersReport.vue?vue&type=script&lang=js"
export * from "./ElectionOfficersReport.vue?vue&type=script&lang=js"

import "./ElectionOfficersReport.vue?vue&type=style&index=0&id=60fee8a5&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fee8a5"]])

export default __exports__